"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationError = void 0;
class ConfigurationError extends Error {
    constructor(msg) {
        super(msg ? `ConfigurationError: ${msg}` : "ConfigurationError");
    }
}
exports.ConfigurationError = ConfigurationError;
//# sourceMappingURL=ConfigurationError.js.map